import ApiStepBaseView from './base';
import app from '../../../app/app';
import templateWebpack from '../../../../tpl/item/api-step/bank-payment.hbs';
import * as Constants from '../../../config/constants';


export const BANK_PAYMENT_STEPS = {
    [Constants.NETMATCH_STEP_PAYMENT_BANK_TRANFER]: 'bankTransfer',
    [Constants.NETMATCH_STEP_PAYMENT_BANCONTACT]: 'bancontact',
    [Constants.NETMATCH_STEP_PAYMENT_IDEAL]: 'ideal'
};

export default class BankPaymentApiStep extends ApiStepBaseView {
    constructor (options = {}) {
        super({
            templateWebpack,
            ...options
        });
    }


    regions () {
        return {
            [Constants.NETMATCH_INPUT_PAYMENT_BANK_TRANFER_ACKNOWLEDGED]: {
                el: '.api-input-Acknowledged',
                replaceElement: true
            }
        };
    }

    apiInputViewOptions () {
        return {
            [Constants.NETMATCH_INPUT_PAYMENT_BANK_TRANFER_ACKNOWLEDGED]: {
                additionalTemplateContext: {
                    hidden: true
                }
            }
        };
    }

    /**
     * Add details to the data passed into the template.
     * Will be merged into the model / collection data.
     */
    templateContext () {
        const templateContext = super.templateContext.apply(this);
        const paymentMessages = app.contentApi.messages.prepareMessages('payment');
        return {
            ...templateContext,
            bankPaymentHintHtml: paymentMessages[this.options.bankPaymentMessageKey],
            label: Constants.NETMATCH_INPUT_PAYMENT_BANK_TRANFER_ACKNOWLEDGED
        };
    }

    onRender () {
        this.renderApiInputsToRegions(this.model.inputs);
        if (this.apiInputViews[Constants.NETMATCH_INPUT_PAYMENT_BANK_TRANFER_ACKNOWLEDGED]) {
            this.apiInputViews[Constants.NETMATCH_INPUT_PAYMENT_BANK_TRANFER_ACKNOWLEDGED].model.setInputValue(true);
        }
    }
}
